<template>
  <div>
    <van-popup v-model="showPop" round :style="{width:'90%'}" :close-on-click-overlay="false" get-container="body">
      <div class="content">
        <van-form 
          :show-error-message="false" 
          validate-trigger="onSubmit" 
          validate-first
          input-align="right"
          ref="form"
        >
          <van-field
            required
            v-model="formData.couponName"
            maxlength="10"
            label="优惠券名称"
            placeholder="请输入"
            :rules="[{ required: true, message: '请输入优惠券名称' }]"
          />
          <van-field
            required
            v-model="formData.couponFaceValue"
            label="优惠券面值"
            type="number"
            placeholder="请输入"
            :rules="[{ required: true, message: '请输入优惠券面值' }]"
          >
            <template #extra >
              <span>元</span>
            </template>
          </van-field>
          <van-field
            required
            v-model="formData.useDoorsill"
            maxlength="8"
            label="使用门槛"
            placeholder="请输入"
            :rules="[{ required: true, message: '请输入使用门槛' }]"
          />
          <van-field
            required
            v-model="formData.couponSum"
            type="digit"
            label="优惠券总数量"
            placeholder="请输入"
            :rules="[{ required: true, message: '请输入优惠券总数量' }]"
          >
            <template #extra >
              <span>张</span>
            </template>
          </van-field>
          <van-field
            required
            v-model="formData.everyoneMaxGetNumber"
            label="每人最多领取数量"
            type="digit"
            label-width="10em"
            placeholder="请输入"
            :rules="[{ required: true, message: '请输入每人最多领取数量' }]"
          >
            <template #extra >
              <span>张</span>
            </template>
          </van-field>
          <van-field
            required
            type="textarea"
            :maxlength="100"
            :rows="1"
            autosize
            show-word-limit
            label-width="5em"
            v-model="formData.useRule"
            label="使用规则"
            placeholder="请输入"
            :rules="[{ required: true, message: '请输入使用规则' }]"
          >
          </van-field>
        </van-form>
        <div class="footer">
          <div class="button cancel" @click="cancel">取消</div>
          <div class="button" @click="submit">保存</div>
        </div>
        <div style="height:66px"></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  export default {
    props: {
      isShowAddCouponPop: {
        type: Boolean,
        default: false
      },
      coupon: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    computed: {
      showPop: {
        get() {
          return this.isShowAddCouponPop
        },
        set(val) {
          this.$emit('update:isShowAddCouponPop', val)
        }
      },
      formData: {
        get() {
          return this.coupon
        },
        set(val) {
          this.$emit('update:coupon', val)
        }
      }
    },
    data() {
      return {
        test: "",
        test1: 1
      }
    },
    methods: {
      submit() {
        this.$refs.form.validate()
          .then(res => {
            this.$emit('addSucess', this.formData)
            this.showPop = false
          }).catch(err => {
            this.$toast(err[0].message);
          })
      },
      cancel() {
        this.showPop = false
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .footer {
    box-sizing: border-box
    position absolute;
    left 0
    bottom 0
    height 60px
    width 100%
    display: flex
    align-items: center
    justify-content: space-around
    padding-bottom constant(safe-area-inset-bottom)
    padding-bottom env(safe-area-inset-bottom)
    border-bottom-left-radius: 16px
    border-bottom-right-radius: 16px
    background-color #fff;
    .button {
      padding 10px 40px
      border 1px solid $mainTextColor
      border-radius: 8px
      color #fff
      background-color: $mainTextColor
    }
    .cancel {
      color $mainTextColor
      background: #fff;
    }
  }
</style>